import { Divider, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  box: {
    paddingBottom: "20px",
  },
  ueberschrift: {
    display: "flex",
    alignItems: "baseline",
    alignContent: "flex-end",
    paddingBottom: "35px",
  },
  title: {
    paddingRight: "20px",
  },
  divider: {
    paddingTop: "5px",
    paddingBottom: "5px",
  },
}));

const PageHeaderComponent = ({ title, subtitle, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.box}>
      <div className={classes.ueberschrift}>
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="h4">{subtitle}</Typography>
      </div>
      {children}
      <Divider p={3} />
    </div>
  );
};

export default PageHeaderComponent;
